export function scrollToTop() {
    window.scroll(0, 0);
}

export function scrollIntoView(selector) {
    const element = document.querySelector(selector);
    element.scrollIntoView({ behavior: "smooth" });
}
